import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF", width = "10", height = "10" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.66987 0L10.6699 4.75H0.669876L5.66987 0Z" fill="#EE8D00" />
      <path d="M5.66987 12L10.6699 7.25H0.669876L5.66987 12Z" fill="#EE8D00" />
    </svg>
  );
};

export default memo(Icon);
